import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { getCharacter } from '../../actions/CharacterAction';
import { l10n } from '../../i18n/Localization';
import BackButton from '../BackButton';
import CharacterView from './CharacterView';

class CharacterPage extends Component {
    componentDidMount() {
        const { characterId, character } = this.props;

        if (character === null) {
            this.props.getCharacter(characterId);
        }
    }

    render() {
        const { character } = this.props;

        let head;
        let content;

        if (character !== null) {
            head = (
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content={character.identificationName} />
                    <title>{character.identificationName} - {l10n.productName}</title>
                </Helmet>
            );
            content = (
                <div className="container mt-3">
                    <div className="d-flex justify-content-between mb-3">
                        <BackButton disabled={false} />
                    </div>
                    <CharacterView character={character} showingToOwner={true} />
                </div>
            );
        } else {
            head = (
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content="Loading character" />
                    <title>Loading Character - {l10n.productName}</title>
                </Helmet>
            );
            content = (
                <div className="container mt-3">
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border"></div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                {head}
                {content}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const characters = state.characterState.getCharacterCharacters;
    const { characterId } = ownProps.match.params;

    const character = characters.has(characterId) ? characters.get(characterId) : null;

    return {
        characterId: characterId,
        character: character,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCharacter: (characterId) => {
            dispatch(getCharacter(characterId));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CharacterPage);
